import type { CityListItem } from '@utazzo/shared';

export interface AirportOption {
  /** IATA code - what flight search / the FD flight stores. */
  value: string;
  label: string;
}

/**
 * The airports a flight to / from this city can use: the city's own IATA
 * code first, then its neighbouring airports from the city master (e.g.
 * Interlaken -> ZRH, BRN, GVA). Empty when the city has no code at all.
 */
export const airportOptionsOf = (
  city: Pick<CityListItem, 'name' | 'iataCode' | 'neighbouringAirportCodes'> | null | undefined,
): AirportOption[] => {
  if (!city) return [];
  const own = city.iataCode
    ? [{ value: city.iataCode, label: `${city.name} (${city.iataCode})` }]
    : [];
  const seen = new Set(own.map((o) => o.value));
  const neighbours = (city.neighbouringAirportCodes ?? [])
    .filter((code) => code && !seen.has(code))
    .map((code) => ({ value: code, label: `${code} (neighbouring airport)` }));
  return [...own, ...neighbours];
};
